import {CA_showHelp, showReport} from "../../common/nav";
import {TimeAmountInput} from "../../classes/form/time-amount-input";
import {replaceClickMenuKeywords} from "../click-menu/helpers";
import {getElmText} from "../../common/dom";
import {postAjaxRequest} from "../../common/ajax";

/**
 * Loads special common element logic:
 *
 * Classes that will be detected:
 * 	showHiddenText: Alerts the passed in data-value attribute.
 *
 */
export function loadCommonElementLogic() {
    loadReportLinks();
    loadShowHiddenText();
    loadPrintButton();
    loadBackButton();
    loadLinkButtons();
    loadChangeLocationButtons();
    loadEmailNotificationForm();
    loadCloseButtons();
    loadMessageContent();
    loadToolbar();
    loadFormTitlesAndFancyTitles();
    loadFormGroups();
    loadPasswordInputs();
    loadInputLayouts();
}

function loadReportLinks() {
    const { windowPopupFeatures } = WebpackConfig.ent;

    const showReportLinks = document.querySelectorAll('.showReportLink');
    if (showReportLinks) {
        showReportLinks.forEach((el) => {
            const { link, features = windowPopupFeatures.report } = el.dataset;
            if (!link) {
                console.error("Failed to find link...");
                return;
            }
            const urlLink = replaceClickMenuKeywords(link);
            el.addEventListener('click', function() {
                window.open(urlLink, '_blank', features);
            });
        });
    }
}

function loadShowHiddenText() {
    const showHiddenTextEls = document.querySelectorAll('.showHiddenText');
    if (showHiddenTextEls) {
        showHiddenTextEls.forEach((el) => {
            const {value} = el.dataset;
            el.addEventListener('click', function () {
                alert(value);
            });
        });
    }
}

function loadPrintButton() {
    const printButtonEl = document.getElementById("print-btn");
    if (printButtonEl) {
        const dataset = printButtonEl.dataset;

        printButtonEl.addEventListener('click', function () {
            if (dataset.url) {
                showReport(dataset.url);
            } else {
                window.print();
            }
        });
    }
}

function loadBackButton() {
    const backButtonEl = document.getElementById("back-btn");
    if (backButtonEl) {
        backButtonEl.addEventListener('click', function () {
            window.back();
        });
    }
    document.querySelectorAll('.backBtn').forEach(backBtn => {
        backBtn.addEventListener('click', function() {
            history.back();
        });
    });
}

function loadLinkButtons() {
    const btnEls = document.querySelectorAll('.link-btn');
    if (btnEls) {
        btnEls.forEach((btnEl) => {
            const { link } = btnEl.dataset;
            if (!link) {
                return;
            }

           btnEl.addEventListener('click', () => {
               document.location = link;
           });
        });
    }
}

function loadChangeLocationButtons() {
    const btnEls = document.querySelectorAll(".change-location-btn");
    if (btnEls) {
        btnEls.forEach((btn) => {
            const { url } = btn.dataset;
            btn.addEventListener('click', function() {
                if (url)
                    document.location = url;
            });
        })
    }
}

function loadEmailNotificationForm() {
    const emailNotificationFormEl = document.getElementById('emailNotificationForm');
    if (!emailNotificationFormEl)
        return;

    const enableNotification = document.getElementById('EFenableNotification');
    if (enableNotification) {
        enableNotificationToggle();
        enableNotification.addEventListener('click', function() {
            enableNotificationToggle();
        });
    }
}

function loadCloseButtons() {
    const closeBtnEls = document.querySelectorAll('.closeBtn');
    if (closeBtnEls) {
        closeBtnEls.forEach((el) => {
            el.addEventListener('click', function () {
                window.close();
            });
        });
    }
}

function enableNotificationToggle() {
    const frm = document.Frm;
    if (!frm) {
        console.error("Failed to find Frm on the page...");
        return;
    }

    const enabled = frm.enableNotification.checked;

    const ateTA = new TimeAmountInput(frm, "timeAmountATE");
    if (ateTA.exists())
        ateTA.setEnabled(enabled);

    frm.email_to.disabled = !enabled;
    frm.email_cc.disabled = !enabled;
    frm.email_bcc.disabled = !enabled;
    frm.email_priority.disabled = !enabled;
    frm.email_subject.disabled = !enabled;
    frm.email_body_header.disabled = !enabled;
    frm.email_body_header.disabled = !enabled;
    if (frm.txtSMSToPhone)
        frm.txtSMSToPhone.disabled = !enabled;
}

function loadMessageContent() {
    if (!document.FrmSystemMessage) {
        return;
    }

    const sysMsgElements = document.querySelectorAll('*[id^="sysMsg-"]');
    if (sysMsgElements) {
        let messages;
        if (GlobalEnt.pageData.messages)
            messages = JSON.parse(GlobalEnt.pageData.messages);

        if (messages && sysMsgElements.length !== messages.length) {
            console.error("Count of messages and created message elements is not correct...");
            return;
        }

        for (let i = 0; i < sysMsgElements.length; i++) {
            sysMsgElements[i].addEventListener('click', function () {
                const { hash } = sysMsgElements[i].dataset;

                let msgId;
                if (hash)
                    msgId = hash;
                else if (messages)
                    msgId = messages[i].hash;
                else {
                    console.error('failed to find msgId for system message: ' + i);
                    return;
                }

                document.FrmSystemMessage.msgId.value = msgId;
                document.FrmSystemMessage.submit();
            });
        }
    }
}

function loadToolbar() {

    const actionButtons = document.querySelectorAll('.action-btn');
    if (actionButtons) {
        actionButtons.forEach((actionBtnEl) => {
            const { link, openNewWindow, type } = actionBtnEl.dataset;

            actionBtnEl.addEventListener('click', function() {
                if (type === 'SEND_TEST_SMS') {
                    sendTestSMSMessage();
                } else if (type === 'CYBERLINK_RUN') {
                    CA_launchCL();
                } else if (link) {
                    if (openNewWindow) {
                        const { windowPopupFeatures } = WebpackConfig.ent;
                        window.open(link, "actionWindow", windowPopupFeatures.status);
                        return;
                    }
                    window.location = link;
                }
            });
        });
    }

    function sendTestSMSMessage() {
        let prompt1 = getElmText(document.getElementById('enterPhoneNumber'));
        let prompt2 = getElmText(document.getElementById('enterMessage'));
        if (!prompt1 || !prompt2 || !document.FrmSendTest) {
            console.error("Failed to send Test SMS action: Elements are not correctly defined...");
            return;
        }

        let toInput = prompt(prompt1);
        if (toInput) {
            let bodyInput = prompt(prompt2);
            if (bodyInput) {
                document.FrmSendTest.To.value = toInput;
                document.FrmSendTest.Body.value = bodyInput;
                document.FrmSendTest.submit();
            }
        }
    }

    function CA_launchCL() {
        // Run Cyber Link 2 and if they need a portable link add it to the url
        // add server url, account, and portable link if available
        const { csrfToken } = GlobalEnt.pageData;
        const params = ['_CSRFToken', csrfToken];
        postAjaxRequest('../../../CyberAuditWeb/people/ProcessCyberLinkURLAjax.act', params, (data) => {
            if (!data) {
                console.error('Failed to process CyberLink URL...');
                return;
            }
            window.open(data, "_parent");
        });
    }
}

function loadFormTitlesAndFancyTitles() {
    const { icons } = WebpackConfig;

    const formTitles = document.querySelectorAll('[data-form-title-icon]');
    if (formTitles) {
        formTitles.forEach((formTitleEl) => {
            const { formTitleIcon } = formTitleEl.dataset;
            if (icons[formTitleIcon]) {
                formTitleEl.setAttribute('src', icons[formTitleIcon]);
            } else {
                formTitleEl.setAttribute('src', formTitleIcon);
            }
        });
    }
}

function loadFormGroups() {
    const formGroups = document.querySelectorAll('.form-group');
    if (formGroups) {
        formGroups.forEach((formGroupEl) => {
            const useExpandCollapse = formGroupEl.dataset.useExpandCollapse === 'true';
            if (!useExpandCollapse) {
                return;
            }

            const formGroupBody = formGroupEl.querySelector('.form-group-body');
            const expandCollapseIcon = formGroupEl.querySelector('.expand-collapse-icon');
            const formGroupTitle = formGroupEl.querySelector('.form-group-title-expandable');
            if (!formGroupBody || !expandCollapseIcon || !formGroupTitle) {
                return;
            }

            const shouldExpandByDefault = formGroupEl.dataset.shouldExpandByDefault === 'true';
            updateFormGroupLayout(formGroupEl, formGroupBody, expandCollapseIcon, shouldExpandByDefault);

            formGroupTitle.addEventListener('click', function() {
                const shouldExpand = formGroupBody.style.display === 'none';
                updateFormGroupLayout(formGroupEl, formGroupBody, expandCollapseIcon, shouldExpand);
            });
        })
    }

}

function updateFormGroupLayout(formGroupEl, formGroupBody, expandCollapseIcon, shouldExpand) {
    const { icons } = WebpackConfig;

    formGroupBody.style.display = shouldExpand ? 'block' : 'none';

    while (expandCollapseIcon.firstChild) {
        expandCollapseIcon.removeChild(expandCollapseIcon.lastChild);
    }

    const newIcon = document.createElement('img');
    newIcon.src = shouldExpand ? icons.chevronUp : icons.chevronDown;
    expandCollapseIcon.appendChild(newIcon);
}

function loadPasswordInputs() {
    const passwordInputs = document.querySelectorAll('.ef-password-field');
    if (passwordInputs) {
        passwordInputs.forEach((passwordInput) => {
            const eyeElement = document.createElement('span');
            eyeElement.classList.add('password-eye');
            if (passwordInput.parentNode) {
                eyeElement.appendChild(document.createElement('div'));
                if (passwordInput.parentNode.querySelector('.errorMsg')) {
                    eyeElement.classList.add('input-has-error');
                }
                passwordInput.parentNode.appendChild(eyeElement);
            }

            if (passwordInput.parentNode) {
                const eyeElement = passwordInput.parentNode.querySelector('.password-eye');
                eyeElement.addEventListener('click', function() {
                    const type = passwordInput.getAttribute('type') === 'password' ? 'text' : 'password';
                    passwordInput.setAttribute('type', type);
                    eyeElement.classList.toggle('slash');
                });
            }
        });
    }
}

function loadInputLayouts() {
    const inputLayouts = document.querySelectorAll('.m-input-layout');
    if (inputLayouts) {
        inputLayouts.forEach((inputLayout) => {
            if (inputLayout.querySelector('.floating-label')) {
                const textInput = inputLayout.querySelector('input[type=text]');
                if (textInput) {
                    overrideTextInputToAddCssClassWhenValueChangesProgrammatically(textInput);
                }
            }
        });
    }
}

function overrideTextInputToAddCssClassWhenValueChangesProgrammatically(textInput) {
    const descriptor = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(textInput), 'value');
    Object.defineProperty(textInput, 'value', {
        set: function(value) {
            const hasValue = value !== undefined && value !== "";
            if (hasValue) {
                textInput.classList.add('has-value');
            } else {
                textInput.classList.remove('has-value');
            }
            return descriptor.set.apply(this, arguments);
        },
        get: function() {
            return descriptor.get.apply(this);
        },
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable
    });
}